module.exports = __webpack_public_path__ + "media/video_smartphone_1_de.e04e5512.mp4";